'use strict';

import ClassLogger from 'ClassLogger';

/**
 * The "EpisodePagination" component allows loading more episodes for a show via API.
 */
export default class EpisodePagination {
    /**
     * Returns the class name used by the ClassLogger.
     * @protected
     */
    getClassName () {
        return 'EpisodePagination';
    }

    /**
     * Create a new instance.
     * @param {NavigationHandler} navigationHandler
     * @param {ApiClient} apiClient
     */
    constructor (navigationHandler, apiClient) {
        /** @type {console} */
        this.logger = ClassLogger(this, true);

        this.navigationHandler = navigationHandler;
        this.apiClient = apiClient;

        this.navigationHandler
            .on('ready', () => this.init())
            .on('render', () => this.init());
    }

    /**
     * Find all pagination buttons.
     */
    init () {
        const buttons = document.querySelectorAll('[data-episode-pagination]');

        buttons.forEach(button => {
            if (button.dataset.initialized) return;
            button.dataset.initialized = 'true';

            button.addEventListener('click', (e) => {
                e.preventDefault();
                this.loadMore(button);
            });
        });
    }

    /**
     * @param {HTMLButtonElement} button
     */
    async loadMore (button) {
        const showId = button.dataset.episodePagination;
        const containerSelector = button.dataset.episodeContainer;
        const container = document.querySelector(containerSelector);

        if (!showId || !container) {
            this.logger.error('Missing showId or container', { showId, containerSelector });
            return;
        }

        const currentOffset = parseInt(button.dataset.offset || '0', 10);
        const limit = parseInt(button.dataset.limit || '10', 10);
        const nextOffset = currentOffset + limit;

        button.disabled = true;
        const originalText = button.innerText;
        button.innerText = 'Lade...';

        try {
            const cursor = {
                limit,
                offset: nextOffset,
            };
            const response = await this.apiClient.get(
                `/mediathek/shows/${showId}/episodes/html?cursor=` + btoa(JSON.stringify(cursor)),
            );
            console.log('Response', { response });
            if (response && response.data) {
                let htmlContent = '';
                if (Array.isArray(response.data)) {
                    htmlContent = response.data.join('\n');
                } else {
                    htmlContent = response.data;
                }
                container.insertAdjacentHTML('beforeend', htmlContent);
                button.dataset.offset = nextOffset;

                // Re-trigger events for new elements
                this.navigationHandler.emit('render');

                if (!response.pagination) {
                    button.classList.add('u-hide');
                }
            } else {
                button.classList.add('u-hide');
            }
        } catch (error) {
            this.logger.error('Failed to load episodes', error);
        } finally {
            button.disabled = false;
            button.innerText = originalText;
        }
    }
}
